module.exports = __webpack_public_path__ + "static/media/link-in-bio-br.87090e9b.png";